import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import history from './../utils/history';
import {usersSlice} from "../app/UsersManagement/Users/slice/slice";
import { membersSlice } from '../app/Members/slice/slice';
import masterSlice from '../app/Settings/Masters/slice/slice';
import hrDetailSlice from '../app/HR/slice/slice';
import hrChartSlice from '../app/HRDashboard/slice';
import { hrCompileSlice } from '../app/HRDataView/slice/slice';

const rootReducer = combineReducers({
  router: connectRouter(history),
  hrDetail: hrDetailSlice.reducer,
  users: usersSlice.reducer,
  members: membersSlice.reducer,
  master: masterSlice.reducer,
  hrChart: hrChartSlice.reducer,
  hrCompile: hrCompileSlice.reducer
});

export default rootReducer;
